import React, { useEffect, useState } from "react";
import { colors } from "../../../utils/theme";
import { Link } from "react-router-dom";
import styled from "styled-components";
import Paginator from "../../Paginator";

import { useNavigate } from "react-router-dom";
import { useDataContex } from "../../../hooks/Context/PatientProvider";

const ContainerUpdatePatient = styled.div`
  .paginator {
    padding: 1rem;
    display: flex;
    background-color: ${colors.gris};
    border-radius: 10px 10px 0 0;
    margin-bottom: 2rem;
    justify-content: space-between;
    align-items: center;
    @media (max-width: 550px) {
      flex-direction: column;
    }
  }

  .title {
    color: ${colors.primary};
    font-size: 1.5rem;
    font-weight: bold;
    @media (max-width: 768px) {
      font-size: 1.5rem;
    }
    @media (max-width: 500px) {
      text-align: center;
    }
  }

  .arrow {
    .bx {
      background-color: ${colors.blanco};
      font-size: 2rem;
      color: ${colors.primary};
      border-radius: 50%;
    }
  }
`;

const ContainerFormInfo = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 20px;
  justify-content: center;
  @media (max-width: 1024px) {
    flex-direction: column;
    align-items: center;
  }

  .Form1 {
    width: 45%;
    @media (max-width: 1024px) {
      width: 95%;
    }
  }

  .Form2 {
    width: 45%;
    @media (max-width: 1024px) {
      width: 95%;
    }
  }
`;

const FormInputInfo = styled.div`
  display: flex;
  margin-bottom: 1rem;
  gap: 20px;
  align-items: center;
  @media (max-width: 500px) {
    flex-direction: column;
    align-items: flex-start;
  }
  label {
    width: 20%;
    color: ${colors.third};
    font-weight: 600;
    @media (max-width: 1024px) {
      text-align: center;
    }
    @media (max-width: 500px) {
      text-align: start;
      width: 100%;
    }
  }

  input {
    width: 80%;
    height: 40px;
    border: 1px solid #d9d9d9;
    padding-left: 10px;
    color: ${colors.fifth};
    @media (max-width: 500px) {
      width: 100%;
    }
    &::placeholder {
      color: ${colors.fifth};
    }
  }

  .identificacion {
    width: 10%;
    color: ${colors.fifth};
    @media (max-width: 500px) {
      width: 20%;
    }
  }

  .id_option {
    width: 90%;
  }

  .ID {
    width: 80%;
    display: flex;
    gap: 20px;

    @media (max-width: 500px) {
      width: 100%;
    }
  }

  .radio-input {
    display: flex;

    gap: 10px;
    span {
      color: ${colors.fifth};
    }
    .radio {
      width: 1.5rem;
      height: auto;
    }
  }
`;

const ContainerButton = styled.div`
  display: flex;
  justify-content: center;
  margin-top: 2rem;
  .button {
    width: 20%;
    display: block;
    padding: 0.7rem;
    border: none;
    border-radius: 30px;
    color: ${colors.blanco};
    background-color: ${colors.azul};
    margin-bottom: 2rem;
    font-weight: bold;
    text-decoration: none;
    text-align: center;
    @media (max-width: 1440px) {
      width: 30%;
    }
    @media (max-width: 1024px) {
      width: 40%;
    }
    @media (max-width: 768px) {
      width: 50%;
    }
    @media (max-width: 600px) {
      width: 80%;
    }
    @media (max-width: 350px) {
      font-size: 0.8rem;
    }
  }
`;

export const UpdatePatientComponent = () => {
  const { data, data2 } = useDataContex();
  const dataSet = data?.[data.length - 1];
  const dataSet2 = data2?.[data2.length - 1];

  const parts = [
    dataSet?.birthDay?.field,
    dataSet?.birthMonth?.field,
    dataSet?.birthYear?.field,
  ].filter(Boolean);
  const DateCompletePatient = parts.join(" ").toUpperCase();

  const parts2 = [
    dataSet?.firstName?.field,
    // dataSet?.LastName?.field,
    dataSet?.lastName?.field,
    // dataSet?.LastSurname?.field,
  ].filter(Boolean);
  const NameCompletePatient = parts2.join(" ").toUpperCase();

  const [id, setId] = useState(dataSet?.id?.field || "");
  const [idNumber, setidNumber] = useState(dataSet?.idNumber?.field || "");

  const [Name, setName] = useState(NameCompletePatient);
  const [Date, setDate] = useState(DateCompletePatient);

  const [Phone, setPhone] = useState(dataSet?.phone?.field || "");
  const [Email, setEmail] = useState(dataSet?.email?.field || "");

  const [Policy, setPolicy] = useState(dataSet2?.policy?.field || "");
  const [Zone, setZone] = useState(dataSet2?.zone?.field || "");

  const [atention, setAtention] = useState("presencial");

  const navigate = useNavigate();
  useEffect(() => {
    if (!data || data.length === 0 || !data2 || data2.length === 0) {
      navigate("/PacienteNuevo");
    }
  }, [data, data2, navigate]);

  //
  const PolizaText = Policy.split("-").slice(2).join("-").trim();
  const ZoneText = Zone.split("-")[1];
  

  
  //

  return (
    <ContainerUpdatePatient>
      {/* Cambio de paginas */}

      <Paginator
        prevRoute="/orden"
        nextRoute=""
        title="INFORMACIÓN DEL PACIENTE"
      />

      {/* contenedor de los formularios y los fields */}

      <ContainerFormInfo>
        {/* ------------------------- */}
        <div className="Form1">
          <FormInputInfo>
            <label>DOCUMENTO ID: </label>
            <div className="ID">
              <input
                className="identificacion"
                type="text"
                readOnly
                value={id}
                onChange={(e) => setId(e.target.value)}
              />
              <input
                className="id_option"
                type="text"
                readOnly
                value={idNumber}
                onChange={(e) => setidNumber(e.target.value)}
              />
            </div>
          </FormInputInfo>

          <FormInputInfo>
            <label>NOMBRE</label>
            <input
              type="text"
              readOnly
              value={Name}
              onChange={(e) => setName(e.target.value)}
            />
          </FormInputInfo>

          <FormInputInfo>
            <label>F. NACIMIENTO</label>
            <input
              type="text"
              readOnly
              value={Date}
              onChange={(e) => setDate(e.target.value)}
            />
          </FormInputInfo>

          <FormInputInfo>
            <label>TELÉFONO MOVIL</label>
            <input
              type="text"
              readOnly
              value={Phone}
              onChange={(e) => setPhone(e.target.value)}
            />
          </FormInputInfo>
        </div>

        {/* ---------------------------------- */}
        <div className="Form2">
          <FormInputInfo>
            <label>EMAIL</label>
            <input
              type="text"
              readOnly
              value={Email}
              onChange={(e) => setEmail(e.target.value)}
            />
          </FormInputInfo>

          <FormInputInfo>
            <label>ENTIDAD</label>
            <input
              type="text"
              readOnly
              value={PolizaText}
              onChange={(e) => {
                setPolicy(e.target.value);
              }}
            />
          </FormInputInfo>

          <FormInputInfo>
            <label>ÁREA AFECTADA</label>
            <input
              type="text"
              readOnly
              value={ZoneText}
              onChange={(e) => setZone(e.target.value)}
            />
          </FormInputInfo>

          {/* <FormInputInfo>
            <label>ATENCIÓN:</label>
            <div className="radio-input">
              <input
                type="radio"
                className="radio"
                name="atencionType"
                value="presencial"
                checked={atention === "presencial"}
                onChange={(e) => setAtention(e.target.value)}
              />
              <span>PRESENCIAL</span>
            </div>
          </FormInputInfo> */}
        </div>
      </ContainerFormInfo>
      <ContainerButton>
        <Link className="button" to="/orden">
          ACTUALIZAR INFORMACIÓN
        </Link>
      </ContainerButton>
    </ContainerUpdatePatient>
  );
};
